import React, { useRef } from 'react';
var VeltAutocompleteOptionName = function (props) {
    var userObject = props.userObject, userId = props.userId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-option-name", { ref: ref, "user-object": userObject ? (typeof userObject === 'object' ? JSON.stringify(userObject) : userObject) : undefined, "user-id": userId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltAutocompleteOptionName;
